import { render, staticRenderFns } from "./AdministratorEdit.vue?vue&type=template&id=64114fea&"
import script from "./AdministratorEdit.vue?vue&type=script&lang=js&"
export * from "./AdministratorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports